import { ActivitiesSupport, FormAction, PerformanceCategoriesSupport, QuestionSupport } from '@app/shared/enums';
import { WorkflowStepApiModel } from './WorkflowStepApiModel';
import { AclItemApiModel } from '../../AclItemApiModel';
import { IdNameApiModel } from '../../IdNameApiModel';
import { FormQuestionBaseApiModel } from './FormQuestionBaseApiModel';

export class FormApiModel {
  public Id: number;
  public Name: string;
  public Description: string | null;
  public WhatIsSubject: AclItemApiModel[];
  public ActivitiesSupport: ActivitiesSupport;
  public PerformanceCategoriesSupport: PerformanceCategoriesSupport;
  public QuestionSupport: QuestionSupport;
  public FormAction: FormAction;
  public HideFromTrainers: boolean;
  public AllowHeaderEdits: boolean;
  public HideFromSupervisors: boolean;
  public IsActive: boolean;
  public IsMandatory: boolean;
  public HoursTracking: boolean;
  public HasInstanceNumber: boolean;
  public IsInstanceNumberUniqueWithinPhase: boolean;
  public HasRatingRecommendation: boolean;
  public HasCreatorNarrative: boolean;
  public HasSubjectNarrative: boolean;
  public DisplayRelatedPerformanceData: boolean;
  public DisplayHistoryToSubject: boolean;
  public DisplayCategoryAverage: boolean;
  public HasSummarySupportingDocuments: boolean;
  public EnableForMultipleTrainees: boolean;
  public WorkflowSteps: WorkflowStepApiModel[];
  public Questions: FormQuestionBaseApiModel[];
  public FormPhases: IdNameApiModel[];
  public IsSummaryNotesRequire: boolean;
  public ShowPerformanceCategoryTime: boolean;
  public ShowSkillTime: boolean;
  public ShowCallTypeTime: boolean;
  public ShowSkillsThumbsUpDown: boolean;
  public ShowCallTypeThumbsUpDown: boolean;
  public EnableAttachments: boolean;
  public ShowCallNumber: boolean;
  public ShowPerformanceCategoryScores: boolean;
  public AttachmentDisclaimer: string;
  public HasCitizenFeedback: boolean;

  public deserialize(data: object): FormApiModel {
    Object.assign(this, data);

    this.WhatIsSubject = this.WhatIsSubject.map((x) => new AclItemApiModel().deserialize(x));
    this.WorkflowSteps = this.WorkflowSteps.map((x) => new WorkflowStepApiModel().deserialize(x));

    // Ensure new fields are properly deserialized
    this.ShowPerformanceCategoryTime = !!data['ShowPerformanceCategoryTime'];
    this.ShowSkillTime = !!data['ShowSkillTime'];
    this.ShowCallTypeTime = !!data['ShowCallTypeTime'];
    this.ShowSkillsThumbsUpDown = !!data['ShowSkillsThumbsUpDown'];
    this.ShowCallTypeThumbsUpDown = !!data['ShowCallTypeThumbsUpDown'];
    this.EnableAttachments = !!data['EnableAttachments'];
    this.ShowCallNumber = !!data['ShowCallNumber'];
    this.ShowPerformanceCategoryScores = !!data['ShowPerformanceCategoryScores'];

    return this;
  }
}
